import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { getProducerLocation, parseProducerImageUrl, parseProducerReadMoreLink } from 'utils/producer'
import { SelectProducerCardProps } from './types'
import styles from './SelectProducerCard.module.scss'
import ProducerLocation from 'components/producer-location/ProducerLocation'
import { Heading, Tag } from '@boltenergy-be/design-system'
import { useGetLanguage } from 'hooks/use-get-language'
import { ProducerEnergyType } from 'types/producer.ts'
import parse from 'html-react-parser'

const SelectProducerCard = ({ producer, activeProducerId, handleSelectProducer, tag }: SelectProducerCardProps) => {
  // i18n
  const { t } = useTranslation()
  const language = useGetLanguage()
  const lowerCaseLanguage = useGetLanguage('lowercase')

  return (
    <button
      className={classNames(styles.container, { [styles.active]: producer.id === activeProducerId })}
      onClick={() => handleSelectProducer(producer)}
    >
      {!!tag && (
        <Tag type="informative" size="small" className={styles.tag}>
          {tag}
        </Tag>
      )}
      <img
        className={styles.image}
        src={parseProducerImageUrl(producer.images?.profile?.url, 600)}
        alt={`${producer.name[lowerCaseLanguage]} thumbnail`}
      />
      <div className={styles.content}>
        <ProducerLocation
          energyType={producer.energyType}
          location={getProducerLocation(lowerCaseLanguage, producer?.location)}
          energyName={t(($) => $.energyType[producer.energyType || ProducerEnergyType.WIND], {
            ns: 'producer'
          })}
        />

        <div>
          <Heading as="h3" variant="h4" serif className="mb-200 truncate">
            {parse(producer.name[lowerCaseLanguage])}
          </Heading>
          <div className={styles.text}>
            {producer.description[lowerCaseLanguage]}{' '}
            <a
              href={parseProducerReadMoreLink(producer.slug, language)}
              rel="noopener noreferrer"
              target="_blank"
              className={styles['read-more']}
              onClick={(e) => e.stopPropagation()}
            >
              {t(($) => $.readMore)}
            </a>
          </div>
        </div>
      </div>
    </button>
  )
}

export default SelectProducerCard
